export const ENGLISH_ABBREV = "en" as const;
export const SPANISH_ABBREV = "es" as const;

export type LanguageCode = typeof ENGLISH_ABBREV | typeof SPANISH_ABBREV;

/**
 * Derives the list of available languages from a pdf_urls_by_language map,
 * ensuring English is always present and listed first.
 */
export const getAvailableLanguages = (
  pdfUrlsByLanguage: Record<string, string> | undefined,
): string[] => {
  const langs = Object.keys(pdfUrlsByLanguage ?? {});
  if (!langs.includes(ENGLISH_ABBREV)) langs.unshift(ENGLISH_ABBREV);
  return langs;
};
